<template lang="html">
  <div class="commment-list">
    <loadData
      viewName="experienceList"
      :fetchData="experienceList"
      :fetchMethod="getExperience"
      :controlPage="changePage"
      :page="page"
      :pageSize="size"
      :firstFetch="firstFetch"
      :hasErr="hasErr"
      :otherParams="{ errText: '暂无评价' }"
    />
    <!-- <imagePreview :items="previewImages"></imagePreview> -->
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import loadData from '@/components/loadMore'
// import imagePreview from '@/components/common/viewImage'
import empty from '@/components/common/empty'

export default {
  data() {
    return {
      page: 1,
      size: 10,
      firstFetch: true,
      hasErr: false,
      uid: null,
      circle_id: '', // 圈子ID
      time_stamp: ''
    }
  },
  async created() {
    this.uid = this.$route.params.uid
    this.circle_id = this.$route.query.circleId || ''
    if (this.circle_id === '') {
      const config = await this.$store.dispatch('getMainConfig')
      this.circle_id = config.data.circleId
    }
    this.getExperience()
    this.$$title('我的育儿经')
    this.$$loading(false)
  },
  methods: {
    async getExperience() {
      try {
        const param = {
          to_uid: this.uid,
          page: this.page,
          limit_num: this.size,
          column_tag_id: this.circle_id
        }
        if (this.page > 1) {
          param.time_stamp = this.time_stamp
        }
        const experience_list = await this.$store.dispatch(
          'getExperienceList',
          param
        )
        if (experience_list.code === 1001) {
          this.hasErr = false
          const last = this.experienceList.slice(-1)
          if (last.length > 0) {
            this.time_stamp = last[0].time_stamp
          }
        } else {
          this.$$toast({
            message: experience_list.message
          })
          this.hasErr = true
        }
        this.firstFetch = false
      } catch (e) {
        this.firstFetch = false
        this.$$toast('网络异常，请刷新重试')
        this.hasErr = true
      }
    },
    changePage(page) {
      this.page = page
    }
  },
  components: {
    loadData,
    // imagePreview,
    empty
  },
  computed: {
    ...mapState(['experienceList', 'previewImages'])
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.commment-list {
  padding-top: rem(20px);
}
</style>
